/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 16:21:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:11:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/index.tsx
 */
import React from 'react';
import Layout from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoriesProducts, getRootUuid } from './slice';
import { useParams } from 'react-router-dom';
import Root from './Root';
import groupGenerate from './CollapseGroupContainer';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';
//import { breadcrumbData } from 'src/pages/SalesChannelCategory/slice/common';

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
} from 'src/types/common/resources';

const permissions = (saleChannelUuid) => {
  const canView = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelCategory,
        subCategory: EnumSubCategory.ChannelProductCategory,
        operation: EnumOperation.view_category_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelCategory,
        subCategory: EnumSubCategory.ChannelProductCategory,
        operation: EnumOperation.add_edit_category,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelCategory,
        subCategory: EnumSubCategory.ChannelProductCategory,
        operation: EnumOperation.delete_category,
      }),
    ],
  });
  return { canView, canCreate, canDelete };
};

const CategoryProduct = (props) => {
  const _p: { uuid: string } = useParams();
  const { uuid } = _p;
  const _d = useDispatch();
  const rootUuid = useSelector(getRootUuid());
  const userPermissions = permissions(uuid);

  React.useEffect(() => {
    _d(fetchCategoriesProducts({ uuid }));
  }, []);

  const Child = () => {
    if (true) {
      return [
        { element: Header, id: 'Header', p: { uuid, userPermissions } },
        ...(userPermissions.canView
          ? [
              ...(rootUuid
                ? [
                    {
                      element: Root,
                      id: 'Root',
                      p: {
                        uuid: rootUuid,
                        salesChannelUuid: uuid,
                        userPermissions,
                      },
                    },
                  ]
                : []),
              ...groupGenerate({ salesChannelUuid: uuid, userPermissions }),
            ]
          : []),
      ];
    } else {
      return [];
    }
  };
  return <Layout elements={Child()} />;
};

export default SalesChannelModeAccessControlHOC(CategoryProduct);
